var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.30331 11.0833L1.33331 13.125V2.33333C1.33331 2.17862 1.40355 2.03025 1.52858 1.92085C1.6536 1.81146 1.82317 1.75 1.99998 1.75H14C14.1768 1.75 14.3464 1.81146 14.4714 1.92085C14.5964 2.03025 14.6666 2.17862 14.6666 2.33333V10.5C14.6666 10.6547 14.5964 10.8031 14.4714 10.9125C14.3464 11.0219 14.1768 11.0833 14 11.0833H4.30331ZM2.66665 10.7246L3.84198 9.91667H13.3333V2.91667H2.66665V10.7246ZM8.94265 6.41667L10.5926 7.86042L9.64998 8.68525L7.99998 7.2415L6.34998 8.68583L5.40731 7.861L7.05731 6.41667L5.40665 4.97292L6.34931 4.14808L7.99998 5.59183L9.64998 4.14808L10.5926 4.97292L8.94265 6.41667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.c254c2deac25e5baf99954da80eda6b9.svg";
export { ForwardRef as ReactComponent };